export const getStatusStyle = (id: number) => {
  switch (id) {
    case 1:
      return "green";
    case 2:
      return "yellow";
    case 3:
      return "red";
    case 4:
      return "blue";
    case 5:
      return "orange";
  }
};
